import { HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CategoryRepository } from '@asm/features/sync/repositories/category.repository';

/**
 * Handler offline para dados de catálogo.
 * Cobre: GET /category/select
 */
@Injectable({ providedIn: 'root' })
export class CatalogOfflineHandler {
  private readonly categoryRepo = inject(CategoryRepository);

  canHandle(req: HttpRequest<unknown>): boolean {
    return req.method === 'GET' && req.url.includes('/category/select');
  }

  async handle(req: HttpRequest<unknown>): Promise<HttpResponse<unknown>> {
    return new HttpResponse({ status: 200, body: await firstValueFrom(this.categoryRepo.getAll()) });
  }
}
